import { render, staticRenderFns } from "./OnlineShopProductPricingLayout.vue?vue&type=template&id=7249ef62&scoped=true&"
import script from "./OnlineShopProductPricingLayout.vue?vue&type=script&lang=js&"
export * from "./OnlineShopProductPricingLayout.vue?vue&type=script&lang=js&"
import style0 from "./OnlineShopProductPricingLayout.vue?vue&type=style&index=0&id=7249ef62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7249ef62",
  null
  
)

export default component.exports